import styled from "@emotion/styled";


export const FlexDiv = styled("div")(({ theme }) => ({
    display: "flex" ,
    justifyContent : "center" ,
    alignItems : "center" ,
    flexDirection : "column" ,
}));